import * as tslib_1 from "tslib";
import { throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from '../../../services/base.service';
import { Constants } from '../../../constants/app.constant';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var TicketRecordService = /** @class */ (function (_super) {
    tslib_1.__extends(TicketRecordService, _super);
    function TicketRecordService(http) {
        var _this = _super.call(this, 'virtual_good_order', http) || this;
        _this.http = http;
        return _this;
    }
    TicketRecordService.prototype.ngOnInit = function () {
    };
    TicketRecordService.prototype.getAllByPaging = function (searchCondition, paging) {
        if (!searchCondition) {
            searchCondition = '';
        }
        return this.http.get(this.url + "?" + paging.getPagingStr() + (this.embeddedStr + searchCondition) + "&sort=id,desc").pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    TicketRecordService.prototype.getAllCouponRecordByPaging = function (searchCondition, paging) {
        if (!searchCondition) {
            searchCondition = '';
        }
        var ticketStr = '&f_category=3&f_category_op==';
        return this.http.get(Constants.API_ENDPOINT + "v1/virtual_good_order?" + paging.getPagingStr() + (this.embeddedStr + searchCondition + ticketStr) + "&sort=id,desc").pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    TicketRecordService.prototype.getAllByBusinessIdByPaging = function (searchCondition, businessId, paging) {
        if (!searchCondition) {
            searchCondition = '';
        }
        return this.http.get(this.url + "?" + paging.getPagingStr() + (this.embeddedStr + searchCondition) + "&sort=id,desc" + (businessId ? "&f_businessId=" + businessId + "&f_businessId_op==" : '')).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    TicketRecordService.prototype.getAllByWalletIdsByPaging = function (walletIds, paging) {
        var sortStr = '&sort=id,asc';
        var walletIdsStr = '';
        if (walletIds) {
            walletIds.forEach(function (id) {
                walletIdsStr += "&f_acceptedMerchants=" + id;
            });
        }
        if (walletIdsStr) {
            walletIdsStr += '&f_acceptedMerchants_op=IN';
        }
        return this.http.get(this.url + "?" + paging.getPagingStr() + walletIdsStr + sortStr).pipe(map(function (response) { return response; }), catchError(function (res) { return observableThrowError(res); }));
    };
    TicketRecordService.ngInjectableDef = i0.defineInjectable({ factory: function TicketRecordService_Factory() { return new TicketRecordService(i0.inject(i1.HttpClient)); }, token: TicketRecordService, providedIn: "root" });
    return TicketRecordService;
}(BaseService));
export { TicketRecordService };
